const PrintIcon = () => {
  return (
    <svg viewBox="0 0 18 15.923">
      <path
        d="M35.04,63.156a.694.694,0,0,0-.692.692v1.385H46.809V63.849a.694.694,0,0,0-.692-.692Zm-2.077,3.462A1.384,1.384,0,0,0,31.578,68v6.231a1.384,1.384,0,0,0,1.385,1.385h1.385v3.462H46.809V75.618h1.385a1.384,1.384,0,0,0,1.385-1.385V68a1.384,1.384,0,0,0-1.385-1.385Zm2.769,4.154h9.692v6.923H35.732Z"
        transform="translate(-31.578 -63.156)"
      />
    </svg>
  );
};

export default PrintIcon;
